<template>
  <div class="dashboard-page">
    <div class="container text-center">
      <!-- Welcome -->
      <div class="welcome-box">
        <h1>Welcome, {{ studentName }}</h1>
        <p class="subtitle">Student Dashboard</p>
      </div>

      <!-- Cards -->
      <div class="row g-3 justify-content-center">
        <div class="col-6 col-md-4 col-lg-3">
          <div class="dashboard-card video">
            <i class="bi bi-play-circle-fill"></i>
            <p>Video Lessons</p>
          </div>
        </div>

        <div class="col-6 col-md-4 col-lg-3">
          <div class="dashboard-card materials">
            <i class="bi bi-journal-text"></i>
            <p>Study Materials</p>
          </div>
        </div>

        <div class="col-6 col-md-4 col-lg-3">
          <div class="dashboard-card schedule">
            <i class="bi bi-calendar-event"></i>
            <p>Schedule</p>
          </div>
        </div>

        <div class="col-6 col-md-4 col-lg-3">
          <div class="dashboard-card payment">
            <i class="bi bi-credit-card"></i>
            <p>Payments</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { studentName: "" };
  },
  mounted() {
    this.studentName = localStorage.getItem("firstName") || "Student";
  },
};
</script>

<style scoped>
.dashboard-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #0d0015, #1a0026);
  display: flex;
  align-items: center;
}

.welcome-box {
  margin-bottom: 40px;
  animation: fadeDown 0.8s ease;
}

h1 {
  font-size: 38px;
  color: white;
  font-weight: 600;
}

.subtitle {
  color: #aaa;
  letter-spacing: 2px;
}

/* Card */
.dashboard-card {
  border-radius: 14px;
  padding: 22px 10px;
  color: white;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s ease;
  animation: floatUp 0.7s ease;
}

.dashboard-card i {
  font-size: 28px;
  margin-bottom: 8px;
}

.dashboard-card p {
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

/* Card Colors */
.video {
  background: linear-gradient(135deg, #ff00cc, #6a00ff);
}

.materials {
  background: linear-gradient(135deg, #00c6ff, #0072ff);
}

.schedule {
  background: linear-gradient(135deg, #00ff9d, #00c46a);
}

.payment {
  background: linear-gradient(135deg, #ff7a18, #ff3d00);
}

/* Hover animation */
.dashboard-card:hover {
  transform: translateY(-6px) scale(1.03);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.4);
}

/* Animations */
@keyframes floatUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile */
@media (max-width: 576px) {
  h1 {
    font-size: 28px;
  }

  .dashboard-card {
    padding: 18px 8px;
  }

  .dashboard-card i {
    font-size: 24px;
  }
}
</style>
